import styled from "styled-components";
import { Paper } from "@material-ui/core";

export const STPaper = styled(Paper)`
  &&& {
    overflow-x: auto;
  }
`;
